import { Modal } from 'antd'
import styled from 'styled-components'

export const AppModal = styled(Modal)`
  && .ant-modal-content {
    overflow: hidden;
    border: 1px solid #dfe6f0;
    border-radius: 14px;
    padding: 0 !important;
    box-shadow: 0 22px 52px rgba(25, 58, 105, 0.18);
  }

  && .ant-modal-header {
    margin: 0;
    border-bottom: 1px solid #e8edf4;
    padding: 10px 14px 9px;
    background: #fff;
  }

  && .ant-modal-title {
    width: 100%;
    color: #102449;
    font-family: var(--font-montserrat);
    font-size: 1.25rem;
    font-weight: 720;
    letter-spacing: -0.025em;
  }

  && .ant-modal-close {
    top: 7px;
    inset-inline-end: 10px;
  }

  && .ant-modal-body {
    max-height: calc(100dvh - 170px);
    overflow-y: auto;
    padding: 10px 14px 14px;
    background: #fbfcfe;
  }

  && .ant-modal-footer {
    margin: 0;
    border-top: 1px solid #e8edf4;
    padding: 10px 14px;
    background: #fff;
  }

  @media (max-width: 640px) {
    width: calc(100vw - 24px) !important;
    max-width: none;
    margin: 12px auto;

    && .ant-modal-header,
    && .ant-modal-body,
    && .ant-modal-footer {
      padding-inline: 12px;
    }
  }
`
